import React, { useState } from "react";
import { Form, Field } from "react-final-form";
import getConfig from "next/config";
import InputText from "@components/Form/InputText";
import InputCheckbox from "@components/Form/Checkbox";
import Textarea from "@components/Form/Textarea";
import Button from "@components/Button";
import { connect } from "react-redux";
import {
  composeFormValidators,
  isRequired,
  isPhoneNumber,
  isAlphaNumeric,
  hasMaxLength,
} from "@lib/validations";
import Alert from "./Alert";
import { apiCall } from "@store/app/actions";
import { sendContactsIncidentApi } from "@lib/api";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const TelesalesForm = ({ apiCall }) => {
  const [sent, setSent] = useState(false);

  const onSubmit = async (values) => {
    // eslint-disable-next-line no-unused-vars
    const { agree_terms, ...payload } = values;

    await apiCall({
      apiArgs: [payload],
      apiCall: sendContactsIncidentApi,
      spinner: true,
      alert: true,
      returnResponse: false,
      postSuccess: () => {
        setSent(true);
      },
    });
  };

  if (sent) {
    return (
      <Alert type="success" showIcon={true}>
        Formularul a fost trimis.
      </Alert>
    );
  }
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        Name: "",
        Subject: "Telesales",
        Email: "",
        Phone: "",
        Message: "",
        InteractionChannel: "aea12a69-73da-ef11-8ee9-6045bd985279",
        InteractionType: "b2c027b9-280e-44d7-b7e0-000000000019",
        InteractionMotive: "925f82c1-7eda-ef11-8ee9-6045bd8ccddd",
        InteractionSubmotive: null,
        StoreId: settings.websiteId,
        StoreName: settings.websiteName,
        origin: "telesales",
      }}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate={true} className="mx-auto">
          <div className="flex flex-col space-y-3">
            <div>
              <Field
                component={InputText}
                name="Name"
                label="Nume si Prenume"
                required
                validate={composeFormValidators(
                  isRequired(),
                  isAlphaNumeric(),
                  hasMaxLength(60)
                )}
                inputClassName="!max-w-full"
              />
            </div>

            <div>
              <Field
                name="Email"
                type="email"
                label={`Email`}
                component={InputText}
                inputClassName="!max-w-full"
              />
            </div>

            <div>
              <Field
                name="Phone"
                type="tel"
                label={`Numar de telefon`}
                tooltip={
                  <>
                    Sunt acceptate numere de telefon fix sau mobil, doar din
                    Romania, formate din 10 cifre, fara prefix international.
                    <br />
                    Ex: 07XXXXXXXX; 02XXXXXXXX.
                  </>
                }
                component={InputText}
                // inputClassName={"max-w-400pxi px-20pxi"}
                required
                validate={composeFormValidators(isRequired(), isPhoneNumber())}
                inputClassName="!max-w-full"
              />
            </div>

            <div>
              <Field
                // className="!w-full !max-w-full h-32"
                name="Message"
                label="Detalii"
                type="textarea"
                component={Textarea}
                required
                validate={composeFormValidators(
                  isRequired(),
                  hasMaxLength(100)
                )}
                inputClassName="!max-w-full"
              />
            </div>

            <div>
              <Field
                component={InputCheckbox}
                name="agree_terms"
                label="Sunt de acord cu prelucrarea datelor cu caracter personal"
                type="checkbox"
                required
                validate={isRequired()}
              />
            </div>
          </div>

          <div className="mt-10 w-full flex justify-center">
            <div className="w-full md:w-318px">
              <Button
                title="Trimite"
                display="block"
                size="normal"
                variant="secondary"
                type="submit"
              />
            </div>
          </div>
        </form>
      )}
    />
  );
};

export default connect(null, { apiCall })(TelesalesForm);
